import electron from './electron.js';

import state from "../state.js";

import CONFIG from "../CONFIG.js";
let _timer;

function _active(){

	console.log(CONFIG.inactivity_timeout);
	if(!electron.electron) return;
	if(_timer) clearTimeout(_timer);
	_timer=setTimeout(()=>{
		console.log('reinit');
		_timer=undefined;
		state.reinit();
	},CONFIG.inactivity_timeout);
}

if(electron.electron){
	_active();
	window.addEventListener('pointerdown',_active,true);
	window.addEventListener('pointermove',_active,true);
	window.addEventListener('pointerup',_active,true);
}

export default {};